/** Zakupy → Prognoza zakupów: prognoza, do zamówienia, dostawcy i karta dostawcy (klucze: pur.*). */
export const purPl = {
  nav: 'Prognoza zakupów',
  page: {
    title: 'Prognoza zakupów',
    description: 'Zapotrzebowanie całej firmy, ilości do zamówienia i dostawcy — dane z InsERT GT (tylko odczyt).',
    tabs: { forecast: 'Prognoza', toOrder: 'Do zamówienia', suppliers: 'Dostawcy' },
  },
  demo: 'dane przykładowe',
  demoHint: 'Część danych to dane przykładowe (otwarte zamówienia do dostawców z ilościami i przyjęcia po dacie kopii ERP) — w InsERT ich nie ma.',
  filters: {
    supplier: 'Dostawca',
    allSuppliers: 'Wszyscy dostawcy',
    group: 'Grupa towarów',
    allGroups: 'Wszystkie grupy',
    search: 'Szukaj towaru lub symbolu…',
    period: 'Okres',
    days: '{n} dni',
  },
  toOrder: {
    horizon: 'Horyzont',
    days: '{n} dni',
    onlyToOrder: 'Tylko do zamówienia',
    all: 'Wszystkie towary',
    export: 'Eksport XLS dla kupca',
    exporting: 'Przygotowuję plik…',
    exportError: 'Nie udało się przygotować pliku',
    note: 'Prognoza na {days} dni od {date} − stan magazynu − zamówione u dostawców (nie mniej niż 0). Zamówienie składasz w InsERT — NEXOPS nic nie zapisuje do ERP.',
    stockAsOf: 'Stan magazynu z odczytu ERP: {date}',
    noStock: 'Brak odczytu stanów magazynowych — uruchom źródło „Zakupy i stany” w Dzienniku synchronizacji.',
    kpi: {
      toOrder: 'Do zamówienia',
      toOrderHint: '{n} z {total} towarów z prognozą',
      value: 'Wartość wg ostatnich cen',
      valueHint: 'ilość do zamówienia × ostatnia cena zakupu',
      stock: 'Stan magazynu (wartość)',
      stockHint: 'towary z listy, wg cen ewidencyjnych',
      open: 'Zamówione u dostawców',
      openHint: 'towary z otwartym zamówieniem ZD',
    },
    col: {
      product: 'Towar',
      supplier: 'Dostawca',
      forecast: 'Prognoza',
      stock: 'Stan',
      open: 'Zamówione',
      toOrder: 'Do zamówienia',
      price: 'Ost. cena',
      value: 'Wartość',
      cover: 'Pokrycie',
    },
    reserved: 'w tym rezerw. {v}',
    next: 'dostawa {date}',
    perDay: '{v} / dzień',
    coverDays: '{n} dni',
    none: 'Nic do zamówienia przy tych filtrach.',
    title: 'Ilości do zamówienia',
    tableHint: 'Najpilniejsze na górze: wartość do zamówienia, potem najkrótsze pokrycie. Dostawca = główny dostawca towaru (największy zakup po PZ w 90 dni).',
  },
  sup: {
    kpi: {
      pz: 'Zakup po PZ',
      pzHint: '{n} przyjęć od dostawców',
      fz: 'Faktury zakupu (FZ)',
      fzHint: '{n} faktur',
      kfz: 'Korekty zakupu (KFZ)',
      kfzHint: '{n} korekt',
      suppliers: 'Dostawcy',
      suppliersHint: '{n} towarów przyjętych',
    },
    months: 'Zakupy miesiąc po miesiącu',
    monthsHint: 'Wartość netto przyjęć (PZ), faktur zakupu (FZ) i korekt (KFZ) wg daty dokumentu.',
    legend: { pz: 'PZ', fz: 'FZ', kfz: 'KFZ' },
    table: 'Dostawcy wg zakupu po PZ',
    tableHint: 'Kliknij dostawcę, aby otworzyć kartę dostawcy.',
    col: {
      supplier: 'Dostawca',
      pz: 'Zakup po PZ',
      share: 'Udział',
      docs: 'PZ',
      fz: 'FZ',
      kfz: 'KFZ',
      products: 'Towary',
      onTime: 'Terminowość',
      lastPz: 'Ostatnia PZ',
    },
    products: 'Towary — zakup po PZ',
    productsHint: 'Ilość i wartość przyjęć w okresie, cena pierwszej i ostatniej dostawy. Kliknij towar, aby zobaczyć cenę zakupu w czasie.',
    pcol: {
      product: 'Towar',
      qty: 'Ilość',
      net: 'Wartość',
      avg: 'Śr. cena',
      first: 'Pierwsza',
      last: 'Ostatnia',
      change: 'Zmiana',
      main: 'Główny dostawca',
    },
    suppliersCount: '{n} dostawców',
    price: 'Cena zakupu w czasie',
    priceHint: 'Cena netto dnia przyjęcia (wartość / ilość), osobno dla każdego dostawcy, ostatnie 12 miesięcy.',
    pickProduct: 'Wybierz towar z tabeli.',
    none: 'Brak zakupów w tym okresie.',
    prev: 'Poprzednie',
    next: 'Następne',
    page: '{from}–{to} z {total}',
  },
  card: {
    title: 'Karta dostawcy',
    since: 'Dostawy od {from} do {to}',
    inactive: 'zablokowany w ERP',
    period: 'Ostatnie 12 miesięcy',
    correctionShare: 'Korekty / faktury',
    timeliness: 'Terminowość dostaw',
    timelinessRule: 'Zamówienie ZD jest dostarczone na czas, gdy pierwsza PZ tego dostawcy (do 14 dni od zamówienia) jest najpóźniej w terminie zamówienia.',
    onTime: 'na czas',
    late: 'spóźnione',
    missing: 'bez dostawy',
    pending: 'w drodze',
    avgDelay: 'śr. spóźnienie {n} dni',
    noOrders: 'Brak zamówień ZD z terminem w tym okresie.',
    products: 'Towary od dostawcy',
    corrections: 'Korekty zakupu',
    noCorrections: 'Brak korekt w tym okresie.',
    ccol: { number: 'Korekta', date: 'Data', amount: 'Kwota', corrected: 'Do faktury', reason: 'Przyczyna' },
    priceChanges: 'Zmiany cen zakupu (≥ 5%)',
    noPriceChanges: 'Brak zmian cen o co najmniej 5%.',
    pccol: { product: 'Towar', date: 'Od', before: 'Było', now: 'Jest', change: 'Zmiana' },
    close: 'Zamknij',
  },
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const purEn: Shape<typeof purPl> = {
  nav: 'Purchase forecast',
  page: {
    title: 'Purchase forecast',
    description: 'Company-wide demand, quantities to order and suppliers — data from InsERT GT (read only).',
    tabs: { forecast: 'Forecast', toOrder: 'To order', suppliers: 'Suppliers' },
  },
  demo: 'sample data',
  demoHint: 'Part of the data is sample data (open supplier orders with quantities and receipts after the ERP copy date) — it does not exist in InsERT.',
  filters: {
    supplier: 'Supplier',
    allSuppliers: 'All suppliers',
    group: 'Product group',
    allGroups: 'All groups',
    search: 'Search product or code…',
    period: 'Period',
    days: '{n} days',
  },
  toOrder: {
    horizon: 'Horizon',
    days: '{n} days',
    onlyToOrder: 'To order only',
    all: 'All products',
    export: 'XLS for the buyer',
    exporting: 'Preparing the file…',
    exportError: 'Could not prepare the file',
    note: 'Forecast for {days} days from {date} − stock − ordered from suppliers (never below 0). The order is placed in InsERT — NEXOPS writes nothing to the ERP.',
    stockAsOf: 'Stock read from the ERP: {date}',
    noStock: 'No stock read yet — run the "Purchasing and stock" feed in the sync log.',
    kpi: {
      toOrder: 'To order',
      toOrderHint: '{n} of {total} forecast products',
      value: 'Value at last prices',
      valueHint: 'quantity to order × last purchase price',
      stock: 'Stock (value)',
      stockHint: 'listed products, at book prices',
      open: 'Ordered from suppliers',
      openHint: 'products with an open supplier order',
    },
    col: {
      product: 'Product',
      supplier: 'Supplier',
      forecast: 'Forecast',
      stock: 'Stock',
      open: 'Ordered',
      toOrder: 'To order',
      price: 'Last price',
      value: 'Value',
      cover: 'Cover',
    },
    reserved: 'incl. reserved {v}',
    next: 'delivery {date}',
    perDay: '{v} / day',
    coverDays: '{n} days',
    none: 'Nothing to order with these filters.',
    title: 'Quantities to order',
    tableHint: 'Most urgent first: value to order, then the shortest cover. Supplier = the main supplier of the product (largest receipts in 90 days).',
  },
  sup: {
    kpi: {
      pz: 'Purchases by receipts',
      pzHint: '{n} supplier receipts',
      fz: 'Purchase invoices',
      fzHint: '{n} invoices',
      kfz: 'Purchase corrections',
      kfzHint: '{n} corrections',
      suppliers: 'Suppliers',
      suppliersHint: '{n} products received',
    },
    months: 'Purchases month by month',
    monthsHint: 'Net value of receipts (PZ), purchase invoices (FZ) and corrections (KFZ) by document date.',
    legend: { pz: 'Receipts', fz: 'Invoices', kfz: 'Corrections' },
    table: 'Suppliers by receipts',
    tableHint: 'Click a supplier to open the supplier card.',
    col: {
      supplier: 'Supplier',
      pz: 'Receipts',
      share: 'Share',
      docs: 'Rec.',
      fz: 'Invoices',
      kfz: 'Corrections',
      products: 'Products',
      onTime: 'On time',
      lastPz: 'Last receipt',
    },
    products: 'Products — purchases by receipts',
    productsHint: 'Quantity and value received in the period, price of the first and the last delivery. Click a product to see its purchase price over time.',
    pcol: {
      product: 'Product',
      qty: 'Quantity',
      net: 'Value',
      avg: 'Avg price',
      first: 'First',
      last: 'Last',
      change: 'Change',
      main: 'Main supplier',
    },
    suppliersCount: '{n} suppliers',
    price: 'Purchase price over time',
    priceHint: 'Net price of the receipt day (value / quantity), per supplier, last 12 months.',
    pickProduct: 'Pick a product from the table.',
    none: 'No purchases in this period.',
    prev: 'Previous',
    next: 'Next',
    page: '{from}–{to} of {total}',
  },
  card: {
    title: 'Supplier card',
    since: 'Deliveries from {from} to {to}',
    inactive: 'blocked in the ERP',
    period: 'Last 12 months',
    correctionShare: 'Corrections / invoices',
    timeliness: 'Delivery timeliness',
    timelinessRule: 'A supplier order is on time when the first receipt from that supplier (within 14 days of the order) is on or before its due date.',
    onTime: 'on time',
    late: 'late',
    missing: 'not delivered',
    pending: 'on the way',
    avgDelay: 'avg delay {n} days',
    noOrders: 'No supplier orders with a due date in this period.',
    products: 'Products from the supplier',
    corrections: 'Purchase corrections',
    noCorrections: 'No corrections in this period.',
    ccol: { number: 'Correction', date: 'Date', amount: 'Amount', corrected: 'Invoice', reason: 'Reason' },
    priceChanges: 'Purchase price changes (≥ 5%)',
    noPriceChanges: 'No price change of 5% or more.',
    pccol: { product: 'Product', date: 'Since', before: 'Was', now: 'Is', change: 'Change' },
    close: 'Close',
  },
};
